<template>
  <section class="section--science-slider" v-if="scientists.length">
    <b-container class="container--wide">
      <b-col class="slider">
        <h2>{{ $t("science.slider") }}</h2>
        <div class="slider__slides">
          <carousel-3d
            :perspective="0" :space="200" :display="showSlides" :width="156" :height="156"
            :inverseScaling="120" :border="0"
            @after-slide-change="slideChanged" :controls-visible="true"
            :clickable="false">
            <slide class="slider__item"
              v-for="(scientist, index) in scientists" :key="index" :index="index">
              <img class="slider__avatar" :src="domain + scientist.photo.url" alt="avatar">
            </slide>
          </carousel-3d>
        </div>
        <div class="slider__content">
          <p class="slider__description" v-html="scientists[activeSlide].content "></p>
          <p class="slider__name">
            <strong>{{ scientists[activeSlide].first_name }}</strong>
            <strong> {{ scientists[activeSlide].last_name }}</strong>
          </p>
          <p>{{ scientists[activeSlide].status }}</p>
        </div>
      </b-col>
    </b-container>
  </section>
</template>

<script>
import scientistsInschool from '@/api/v1/scienceInSchool';

export default {
  data() {
    return {
      activeSlide: 0,
      showSlides: 0,
      scientists: [],
      domain: process.env.SERVER_URL,
    };
  },
  methods: {
    slideChanged(activeSlideIndex) {
      this.activeSlide = activeSlideIndex;
    },
    slideToShow() {
      if (window.innerWidth > 767) {
        this.showSlides = 3;
      } else {
        this.showSlides = 1;
      }
    },
    getScientists() {
      const succ = (response) => {
        this.scientists = response.data.all_science_in_schools;
      };
      scientistsInschool.index(succ);
    },
  },
  created() {
    this.getScientists();
    this.slideToShow();
  },
};
</script>

<style lang="scss" scoped>
@import "./src/styles/helpers/_variables.scss";
@import "./src/styles/helpers/_include-media.scss";

.section--science-slider {
  padding-top: 100px;
  @include media('<lg') {
    padding-top: 50px;
  }
  @include media('<md') {
    padding-top: 40px;
  }
}

.slider{
  background-color: $color--gray-5;
  padding: 91px 40px 77px;
  text-align: center;
  @include media('<lg') {
    padding: 40px 0;
  }
  @include media('<md') {
    padding: 30px 15px;
  }
  &__slides{
    margin-top: 36px;
    .carousel-3d-controls{
      margin-top: 100px;
    }
  }
  &__item{
    background-color: transparent;
    &.current{
      .slider__avatar{
        opacity: 1;
      }
    }
  }
  &__avatar{
    opacity: 0.5;
    border-radius: 50%;
  }
  &__content{
    max-width: 600px;
    margin: 45px auto 0;
    @include media('<lg') {
      max-width: 510px;
    }
    @include media('<md') {
      display: flex;
      flex-direction: column;
    }
  }
  &__description{
    min-height: 165px;
    @include media('<lg') {
      min-height: 50px;
    }
    @include media('<md') {
      order: 3;
    }
  }
  &__name {
    @include media('<lg') {
      font-size: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ScienceInSchool/ScienceSlider.vue